import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const i = r((a, e) => /* @__PURE__ */ s.jsx(
  t,
  {
    ref: e,
    ...a,
    image: (o) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...o,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3668",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M15.25 7.38c-.02-.12 0-.16.07-.34.1-.24.25-.61.15-1.16-.11-.64-.47-.93-.68-1.1-.04-.03-.09-.08-.1-.09-.05-.22-.03-.34-.01-.52.03-.25.08-.59-.1-1.05-.12-.33-.36-.53-.53-.69-.22-.19-.22-.2-.21-.3.05-.54-.08-1-.4-1.35C12.83.13 11.73 0 9.93 0 7.2 0 6.08.88 5.18 1.59c-.3.23-.55.43-.83.56-.76.36-2.08.32-2.52.28a.746.746 0 0 0-.83.66c-.04.41.26.78.67.83.21.02 2.05.2 3.33-.41.42-.21.77-.48 1.1-.74.8-.63 1.62-1.27 3.83-1.27 1.4 0 2.21.1 2.39.3.03.03.03.12.02.2-.09.88.43 1.33.71 1.58.05.04.12.11.12.08.04.11.04.15.01.33-.03.23-.07.55.03 1.02.11.52.43.78.62.94.14.12.14.12.16.21.02.12.01.16-.06.33-.1.24-.24.59-.16 1.12.04.23.1.41.15.53.06.16.08.2.05.37-.02.1-.06.32-.66.32-.41 0-.59-.01-.77-.03-.22-.02-.46-.04-1.05-.04q-1.365 0-1.89.81c-.48.73-.16 1.59-.04 1.84.13.3.52 1.33.02 2.29-.31.6-.7.78-.87.79 0-.18.03-.31.09-.52.12-.42.26-.94.08-1.95-.22-1.26-1.08-1.67-1.65-1.94-.09-.03-.18-.08-.27-.12-.7-.38-1.04-.9-1.4-1.46-.81-1.26-2.46-1.42-3.81-1.42a.749.749 0 1 0 0 1.5c1.42 0 2.23.23 2.55.73.4.63.91 1.41 1.95 1.97.11.06.22.11.33.17.52.25.73.37.82.85.12.67.04.95-.05 1.28-.08.28-.18.63-.14 1.12.05.64.49 1.14 1.12 1.27.11.02.22.03.34.03.75 0 1.65-.47 2.24-1.61.78-1.51.27-3.02.02-3.59-.09-.2-.09-.38-.07-.42.02-.03.18-.13.64-.13.52 0 .72.02.92.03.21.02.42.04.9.04 1.17 0 1.97-.58 2.14-1.56.1-.58-.03-.92-.12-1.16a.5.5 0 0 1-.09-.22"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3668)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyThumbsDownIcon";
export {
  i as AgencyThumbsDownIcon,
  i as default
};
//# sourceMappingURL=index.js.map
